<template>
  <div style="background:#f6f7fa;">
    <Header></Header>
    <div class="mt-3 mb-3">
      <div class="container p-2">
        <h4 class="text-center">历史经典理论</h4>
        <div class="bg-white shadow-sm">
          pdf文件
          <object
            classid="clsid:CA8A9780-280D-11CF-A24D-444553540000"
            width="1000"
            height="1200"
            border="0"
          >
            <param name="_Version" value="65539" />
            <param name="_ExtentX" value="20108" />
            <param name="_ExtentY" value="10866" />
            <param name="_StockProps" value="0" />
            <param name="SRC" :value="product.freeChapter.downloadUrl" />
            <object
              :data="product.freeChapter.downloadUrl"
              type="application/pdf"
              width="1000"
              height="1200"
            ></object>
          </object>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from "../components/header";
import Bottom from "../components/bottom";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Bottom,
  },
};
</script>

<style>
@import url("../assets/style.css");
@import url("../assets/bootstrap.css");
</style>
